import classnames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { isRequesting } from "src/requestProgress/helpers";
import { actions } from "src/requestProgress/reducer";
import { State } from "../../state";
import { formatMoneyValue } from "../../utils/formatters";
import { getHighlightedCellFn } from "../model/highlightedCells/selector";
import { AccountPresenterKind } from "../model/presenter/types";
import { selectCell as selectCellAction } from "../model/selectedCells/actions";
import { getCellSelectedFn } from "../model/selectedCells/selector";
import { getMappingNodeId } from "../model/spread/selector";

interface AccountTotalCellBaseProps {
  account: AccountPresenterKind<"CALCULATED">;
  period: number;
}

interface AccountTotalCellProps extends AccountTotalCellBaseProps {
  isSelected: boolean;
  isHighlighted: boolean;
  selectCell: typeof selectCellAction;
  mappingNodeId: string | null;
}

const valueClass = (
  account: AccountPresenterKind<"CALCULATED">,
  isSelected: boolean,
  isHighlighted: boolean,
  index: number
): string => {
  const documentException = account.documentExceptions[index];

  return classnames(
    "AccountRow__value",
    "AccountRow__value--total",
    `AccountRow__value--period-${index + 1}`,
    {
      "AccountRow__value--error": documentException,
      "AccountRow__value--selected": isSelected,
      "AccountRow__value--highlighted": isHighlighted,
      "AccountRow__value--total--checked": account.exceptionEligible,
      "AccountRow__value--total--unchecked": !account.exceptionEligible
    }
  );
};

export const AccountTotalCell: React.SFC<AccountTotalCellProps> = ({
  account,
  period,
  isSelected,
  isHighlighted,
  selectCell,
  mappingNodeId
}) => {
  const onClick = (event: React.MouseEvent<HTMLTableCellElement>) => {
    event.stopPropagation();
    if (!isRequesting(actions.updateAccount) && mappingNodeId === null) {
      selectCell({
        period,
        account
      });
    }
  };
  const periodValue = account.periodValues[period];

  return (
    <div
      className={valueClass(account, isSelected, isHighlighted, period)}
      onClick={onClick}
    >
      {formatMoneyValue(periodValue ? periodValue : 0)}
    </div>
  );
};

const mapStateToProps = (
  state: State,
  ownProps: AccountTotalCellBaseProps
) => ({
  isSelected: getCellSelectedFn(state)(
    ownProps.account.spreadSheetType,
    ownProps.account.id,
    ownProps.period
  ),
  isHighlighted: getHighlightedCellFn(state)(
    ownProps.account.spreadSheetType,
    ownProps.account.id,
    ownProps.period
  ),
  mappingNodeId: getMappingNodeId(state)
});

export default connect(mapStateToProps)(AccountTotalCell);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/AccountTotalCell.tsx